<loading-component *ngIf="_databaseResourcesService.loading"></loading-component>

<div class="alert alert-warning alert-dismissible fade show" role="alert"
  *ngIf="_resourceService.alert">
  {{ _resourceService.alert | translate }}
  <button type="button" class="close" data-dismiss="alert" aria-label="Close"
    (click)="_resourceService.alert = null">
    <span aria-hidden="true">&times;</span>
  </button>
</div>

<div *ngIf="!_databaseResourcesService.loading">
  <div class="d-flex" *ngIf="_userService.user.role != 'consultant'">
    <div>
      <button type="button" class="btn btn-main-color btn-sm mt-2"
        routerLink="/admin/database-resources/consultants">
        <i class="fa fa-arrow-left" aria-hidden="true"></i>
        <span> {{ 'RETURN' | translate }}</span>
      </button>
    </div>
  </div>

  <hr>

  <h1>
    {{ 'CONSULTANT' | translate}}: {{originalConsultant.name}}
  </h1>
  <small>{{ 'ID' | translate}}:{{consultant.id}}</small>
  <hr>
  <h4>
    {{ 'PERSONAL_INFORMATION' | translate}}
  </h4>
  <hr>

  <form *ngIf="consultant.personalData">
    <div class="form-group row">
      <label for="name" class="col-sm-3 col-form-label">{{ 'NAME' | translate}} *</label>
      <div class="col-sm-9">
        <input class="form-control" type="text" [value]="consultant.personalData.name" name="name"
          [(ngModel)]=consultant.personalData.name [disabled]="action!='update'">
      </div>
    </div>

    <div class="form-group row">
      <label for="lastname" class="col-sm-3 col-form-label">{{ 'LASTNAME' | translate}}
        *</label>
      <div class="col-sm-9">
        <input class="form-control" type="text" [value]="consultant.personalData.lastname"
          name="lastname" [(ngModel)]=consultant.personalData.lastname
          [disabled]="action!='update'">
      </div>
    </div>

    <div class="form-group row  margin-top">
      <label for="id" class="col-sm-3 col-form-label">{{ 'PHONE_NUMBER' | translate}} *</label>
      <div class="col-sm-9">
        <input class="form-control" type="text" [value]="consultant.personalData.phoneNumber"
          name="phoneNumber" [(ngModel)]=consultant.personalData.phoneNumber
          [disabled]="action!='update'">
      </div>
    </div>

    <div class="form-group row  margin-top">
      <label for="id" class="col-sm-3 col-form-label">{{ 'ADDRESS' | translate}}</label>
      <div class="col-sm-9">
        <input class="form-control" type="text" [value]="consultant.personalData.address"
          name="address" [(ngModel)]=consultant.personalData.address [disabled]="action!='update'">
      </div>
    </div>

    <div class="form-group row  margin-top">
      <label for="id" class="col-sm-3 col-form-label">{{ 'FLAT_NUMBER' | translate}}</label>
      <div class="col-sm-9">
        <input class="form-control" type="text" [value]="consultant.personalData.flatNumber"
          name="flatNumber" [(ngModel)]=consultant.personalData.flatNumber
          [disabled]="action!='update'" maxlength="10">
      </div>
    </div>

    <div class="form-group row mt-4">
      <div class="form-group col-md-12" *ngIf="action != 'update'">
        <button type="submit" class="btn btn-main-color btn-block" (click)="action = 'update'">
          {{ 'EDIT' | translate}}
        </button>
      </div>
      <div class="form-group col-md-6" *ngIf="action == 'update'">
        <button type="submit" class="btn btn-main-color btn-block" (click)="updateConsultant()">
          {{ 'UPDATE' | translate}}
        </button>
      </div>
      <div class="col-md-6" *ngIf="action == 'update'">
        <button type="submit" class="btn btn-secondary btn-block" data-dismiss="modal"
          (click)="cancelEdit()">
          {{ 'CANCEL' | translate}}
        </button>
      </div>
    </div>
  </form>

  <hr>

  <div class="row  margin-top-5" *ngIf="_userService.user.role != 'assistant'">
    <div class="col-12">
      <div class="card">
        <div class="card-body">
          <h4 class="card-title">{{ 'ASSISTANTS' | translate}}</h4>
          <div class="d-flex justify-content-end">
            <button class="btn btn-main-color btn-sm  cursor-hand" data-toggle="modal"
              data-toggle="modal" data-target="#addAssistantToConsultantModal">
              {{ 'ADD_NEW_ASSISTANT' | translate }}
            </button>
          </div>
          <h4>
            <span class="badge badge-pill btn-main-color"
              *ngFor="let assistant of consultant.assistants">
              {{assistant.email}} - {{assistant.name}} {{assistant.lastname}}&nbsp;
              <i class="fas fa-times" (click)="removeAssistantFromConsultant(assistant)"></i>
            </span>
          </h4>
        </div>
      </div>
    </div>
  </div>

  <hr>

  <div class="row  margin-top-5">
    <div class="col-12">
      <div class="card">
        <div class="card-body">
          <h4 class="card-title">{{ 'PAYORS' | translate}}</h4>
          <div class="d-flex justify-content-end">
            <button class="btn btn-main-color btn-sm  cursor-hand" data-toggle="modal"
              data-toggle="modal" data-target="#addPayorToConsultantModal">
              {{ 'ADD_NEW_PAYOR' | translate }}
            </button>
          </div>
          <h4>
            <span class="badge badge-pill btn-main-color" *ngFor="let payor of consultant.payors">
              {{payor.name}}&nbsp;
              <i class="fas fa-times" (click)="removePayorFromConsultant(payor)"></i>
            </span>
          </h4>
        </div>
      </div>
    </div>
  </div>


  <hr>

  <div class="d-flex justify-content-end">
    <button class="btn btn-main-color btn-sm  cursor-hand" data-toggle="modal" data-toggle="modal"
      data-target="#addHospitalToConsultantModal">
      {{ 'ADD_NEW_HOSPITAL' | translate }}
    </button>
  </div>


  <ul class="nav nav-tabs" id="hospitalTabs" role="tablist">
    <li class="nav-item" role="presentation"
      *ngFor="let hospitalSchedule of consultant.hospitalSchedules; let index = index">
      <a class="nav-link" [class.active]="index == 0" [class.show]="index == 0"
        [id]="hospitalSchedule.hospital.id + '-tab'" data-toggle="tab"
        [href]="'#' + hospitalSchedule.hospital.id" role="tab"
        (click)="selectedHospital = hospitalSchedule.hospital">{{hospitalSchedule.hospital.name}}</a>
    </li>
  </ul>

  <div class="tab-content" id="hospitalTabsContent">
    <div class="tab-pane fade" [class.active]="index == 0" [class.show]="index == 0"
      [id]="hospitalSchedule.hospital.id" role="tabpanel"
      *ngFor="let hospitalSchedule of consultant.hospitalSchedules; let index = index">

      <div class="row">
        <div class="col-12">
          <div class="card">
            <div class="card-body">
              <h4 class="card-title">{{ 'SUBDEPARTMENTS_CONSULTANT_PROFILE' | translate}}</h4>
              <div class="d-flex justify-content-end">
                <button class="btn btn-main-color btn-sm  cursor-hand"
                  (click)="openModal(hospitalSchedule.hospital)">
                  {{ 'ADD_NEW_SUBDEPARTMENT_CONSULTANT_PROFILE' | translate }}
                </button>
              </div>
              <h4>
                <div class="badge badge-pill btn-main-color"
                  *ngFor="let subdepartment of consultant.subdepartments">
                  <span
                    *ngIf="subdepartment.hospitalId == hospitalSchedule.hospital.id">{{subdepartment.name}}&nbsp;
                    <i class="fas fa-times"
                      (click)="removeSubdepartmentFromConsultant(subdepartment)"></i></span>
                </div>
              </h4>
            </div>
          </div>
        </div>
      </div>

      <div class="row  margin-top-5">
        <div class="col-12">
          <div class="card">
            <div class="card-body">
              <h4 class="card-title">{{ 'SCHEDULE' | translate}}</h4>

              <div class="form-group row">


                <label for="endTime" class="col-sm-2 col-form-label">{{ 'VISIT_DURATION' |
                  translate}}</label>
                <div class="col-sm-2">
                  <input type="number" class="form-control" id="visitDuration"
                    [(ngModel)]=hospitalSchedule.visitDuration [disabled]="!editVisitDuration"
                    min="1">
                </div>

                <div class="form-group col-md-8" *ngIf="!editVisitDuration">
                  <button type="submit" class="btn btn-main-color btn-block"
                    (click)="editVisitDuration = true">
                    {{ 'EDIT' | translate}}
                  </button>
                </div>

                <div class="form-group col-md-4" *ngIf="editVisitDuration">
                  <button type="submit" class="btn btn-main-color btn-block"
                    (click)="editVisitDuration = false; saveVisitDuration(hospitalSchedule)">
                    {{ 'SAVE' | translate}}
                  </button>
                </div>
                <div class="form-group col-md-4" *ngIf="editVisitDuration">
                  <button type="submit" class="btn btn-secondary-color btn-block"
                    (click)="editVisitDuration = false; cancelEdit()">
                    {{ 'CANCEL' | translate}}
                  </button>
                </div>
              </div>
              <hr>
              <h5>{{ 'USUAL_DAYS' | translate}}</h5>

              <div class="alert alert-danger alert-dismissible fade show" role="alert"
                *ngIf="alertShedule">
                {{ alertShedule | translate}}
                <button type="button" class="close" data-dismiss="alert" aria-label="Close">
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>

              <div *ngFor="let scheduleDay of hospitalSchedule?.days">
                <div class="form-check">
                  <input class="form-check-input" type="checkbox" [id]="scheduleDay.has"
                    [value]="scheduleDay.has" [(ngModel)]=scheduleDay.has>
                  <label class="form-check-label" for="defaultCheck1">
                    {{ scheduleDay.name | translate}}
                  </label>
                </div>
                <div *ngIf="scheduleDay.has">
                  <div class="d-flex justify-content-end margin-bottom"
                    *ngIf="!scheduleDay.times || !scheduleDay.times.editing">
                    <button class="btn btn-main-color btn-sm  cursor-hand"
                      (click)="addSchedule(scheduleDay)">
                      {{ 'ADD_NEW_SCHEDULE' | translate }} {{ 'TO' | translate }} {{
                      scheduleDay.name
                      | translate}}
                    </button>
                  </div>
                  <div *ngFor="let time of scheduleDay.times">
                    <div class="form-group row">
                      <label for="startTime" class="col-sm-2 col-form-label">{{ 'START_TIME' |
                        translate}}</label>
                      <div class="col-sm-2">
                        <input type="time" [placeholder]="'START_TIME' | translate"
                          class="form-control" [id]="time.startTime" [value]="time.startTime"
                          [(ngModel)]=time.startTime [disabled]="!time.editing">
                      </div>

                      <label for="endTime" class="col-sm-2 col-form-label">{{ 'END_TIME' |
                        translate}}</label>
                      <div class="col-sm-2">
                        <input type="time" [placeholder]="'END_TIME' | translate"
                          class="form-control" [id]="time.endTime" [value]="time.endTime"
                          [(ngModel)]=time.endTime [disabled]="!time.editing">
                      </div>

                      <div class="form-group col-md-2" *ngIf="!time.editing">
                        <button type="submit" class="btn btn-main-color btn-block"
                          (click)="time.editing = true; scheduleDay.times.editing = true">
                          {{ 'EDIT' | translate}}
                        </button>
                      </div>
                      <div class="form-group col-md-2" *ngIf="!time.editing">
                        <button type="submit" class="btn btn-danger btn-block"
                          (click)="removeTime(time)">
                          {{ 'REMOVE' | translate}}
                        </button>
                      </div>

                      <div class="form-group col-md-2" *ngIf="time.editing">
                        <button type="submit" class="btn btn-main-color btn-block"
                          (click)="time.editing = false; scheduleDay.times.editing = false; saveTime(hospitalSchedule, scheduleDay.name, time)">
                          {{ 'SAVE' | translate}}
                        </button>
                      </div>
                      <div class="form-group col-md-2" *ngIf="time.editing">
                        <button type="submit" class="btn btn-secondary-color btn-block"
                          (click)="time.editing = false; cancelEdit()">
                          {{ 'CANCEL' | translate}}
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <hr>
              <h5>{{ 'EXCEPTIONS' | translate}}</h5>

              <div class="alert alert-danger alert-dismissible fade show" role="alert"
                *ngIf="alertException">
                {{ alertException | translate}}
                <button type="button" class="close" data-dismiss="alert" aria-label="Close">
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>


              <div *ngFor="let exception of hospitalSchedule.exceptions">
                <div class="form-check">
                  <input class="form-check-input" type="checkbox" [id]="exception.has"
                    [value]="exception.has" [(ngModel)]=exception.has
                    [disabled]=exception.times.length>
                  <label class="form-check-label" for="defaultCheck1">
                    {{ 'HAVE_EXCEPTIONS' | translate }}
                  </label>
                </div>
                <div *ngIf="exception.has">
                  <div class="d-flex justify-content-end margin-bottom" *ngIf="!exception.days">
                    <button class="btn btn-main-color btn-sm  cursor-hand"
                      (click)="addException(exception)">
                      {{ 'ADD_NEW_EXCEPTION' | translate }}
                    </button>
                  </div>
                  <div *ngFor="let time of exception.times">
                    <div class="form-group row">
                      <label for="startTime" class="col-sm-1 col-form-label">{{ 'FIRST_DAY' |
                        translate}}</label>
                      <div class="col-sm-3">
                        <input type="date" [placeholder]="'FIRST_DATE' | translate"
                          class="form-control" [id]="time.startTime" [value]="time.startTime"
                          [(ngModel)]=time.startTime [disabled]="!time.editing">
                      </div>

                      <label for="endTime" class="col-sm-1 col-form-label">{{ 'LAST_DAY' |
                        translate}}</label>
                      <div class="col-sm-3">
                        <input type="date" [placeholder]="'LAST_DATE' | translate"
                          class="form-control" [id]="time.endTime" [value]="time.endTime"
                          [(ngModel)]=time.endTime [disabled]="!time.editing">
                      </div>

                      <div class="form-group col-md-2" *ngIf="!time.editing">
                        <button type="submit" class="btn btn-main-color btn-block"
                          (click)="time.editing = true">
                          {{ 'EDIT' | translate}}
                        </button>
                      </div>
                      <div class="form-group col-md-2" *ngIf="!time.editing">
                        <button type="submit" class="btn btn-danger btn-block"
                          (click)="removeTime(time)">
                          {{ 'REMOVE' | translate}}
                        </button>
                      </div>

                      <div class="form-group col-md-2" *ngIf="time.editing">
                        <button type="submit" class="btn btn-main-color btn-block"
                          (click)="time.editing = false; saveTime(hospitalSchedule, exception.name, time)">
                          {{ 'SAVE' | translate}}
                        </button>
                      </div>
                      <div class="form-group col-md-2" *ngIf="time.editing">
                        <button type="submit" class="btn btn-secondary-color btn-block"
                          (click)="time.editing = false;  cancelEdit()">
                          {{ 'CANCEL' | translate}}
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <hr>
              <div class="d-flex justify-content-end">
                <h4>
                  <span class="badge badge-pill btn-danger">
                    {{ 'REMOVE' | translate }} {{ consultant.name}}
                    {{ 'FROM' | translate }}
                    {{hospitalSchedule.hospital.name}}
                    <i class="fas fa-times"
                      (click)="removeConsultantFromHospital(hospitalSchedule.hospital)"></i>
                  </span>
                </h4>
              </div>


            </div>
          </div>
        </div>
      </div>
    </div>

  </div>
</div>

&nbsp;

<!-- Add Hospital to Consultat Modal -->
<div class="modal fade" data-backdrop="static" data-keyboard="false" data-backdrop="static"
  data-keyboard="false" id="addHospitalToConsultantModal" tabindex="-1" role="dialog"
  aria-labelledby="consultantModal" aria-hidden="true">
  <div class="modal-dialog  modal-xl" role="document">
    <div class="modal-content">
      <div class="modal-header btn-main-color">
        <div>{{ 'ADD_HOSPITAL_TO_CONSULTANT' | translate}}</div>
        <h5 class="modal-title" id="addHospitalToConsultantModal"></h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>

      <div class="modal-body">

        <div class="alert alert-warning alert-dismissible fade show" role="alert"
          *ngIf="_resourceService.alert">
          {{ _resourceService.alert | translate }}
          <button type="button" class="close" data-dismiss="alert" aria-label="Close"
            (click)="_resourceService.alert = null">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>

        <div
          *ngIf="consultant.hospitals && _databaseResourcesService.allHospitals.length == consultant.hospitals.length">
          <div class="alert alert-warning alert-dismissible fade show" role="alert">
            {{ 'NO_MORE_HOSPITALS_TO_ADD' | translate }}
          </div>
        </div>

        <div class="form-row"
          *ngIf="consultant.hospitals && _databaseResourcesService.allHospitals.length != consultant.hospitals.length">

          <div class="form-group col-md-12">
            <label>{{ 'CHOOSE_HOSPITAL' | translate}}</label>
          </div>
        </div>
        <div *ngFor="let hospital of _databaseResourcesService.allHospitals">
          <div class="card sm-12 margin-top-5 btn-main-color"
            *ngIf="!areInArray(hospital, consultant.hospitals)"
            (click)="assignHospitalToConsultant(hospital)" data-toggle="modal"
            data-target="#addHospitalToConsultantModal" [title]="'SELECT' | translate">

            <div class="card-header text-row-background-color-white cursor-hand">
              <div class="row">
                <div class="col-7">
                  {{hospital.id}} - {{hospital.name}}
                </div>
                <div class="col-3 text-left tex-element-bold">
                </div>

                <div class="col-2 text-right">
                  <div ngbDropdown class="d-inline-block">
                    <i class="fas fa-hand-pointer" aria-hidden="true"></i>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>












<!-- Add Department to Consultat Modal -->
<div class="modal fade" data-backdrop="static" data-keyboard="false" data-backdrop="static"
  data-keyboard="false" id="addDepartmentToConsultantModal" tabindex="-1" role="dialog"
  aria-labelledby="consultantModal" aria-hidden="true">
  <div class="modal-dialog  modal-xl" role="document">
    <div class="modal-content">
      <div class="modal-header btn-main-color">
        <div>{{ 'ADD_DEPARTMENT_TO_CONSULTANT' | translate}}</div>
        <h5 class="modal-title" id="departmentconsultantModal"></h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>

      <div class="modal-body">

        <div class="alert alert-warning alert-dismissible fade show" role="alert"
          *ngIf="_resourceService.alert">
          {{ _resourceService.alert | translate }}
          <button type="button" class="close" data-dismiss="alert" aria-label="Close"
            (click)="_resourceService.alert = null">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>

        <div class="form-row">

          <div class="form-group col-md-12">
            <label>{{ 'CHOOSE_HOSPITAL' | translate}}</label>
            <div class="input-group mb-3">
              <select name="hospital" class="form-control" [(ngModel)]=hospital
                (ngModelChange)="getDepartments($event)">
                <option disabled hidden [value]="selectUndefinedOptionValue"></option>
                <option *ngFor="let hospital of _databaseResourcesService.allHospitals"
                  [ngValue]="hospital">
                  {{ hospital.name }}
                </option>
              </select>
              <div class="input-group-append">
                <button class="btn btn-outline-secondary"
                  (click)="hospital = null; departments = null" [disabled]="!hospital">
                  <i class="fas fa-trash-alt icon-trash"></i>
                </button>
              </div>
            </div>
          </div>
        </div>

        <loading-component *ngIf="_databaseResourcesService.loading"></loading-component>


        <div class="alert alert-warning margin-top-5" role="alert"
          *ngIf="!_databaseResourcesService.loading && hospital && departments && !departments.length">
          {{ 'HOSPITAL_WITHOUT_DEPARTMENTS' | translate }}
        </div>

        <div *ngIf="departments && departments.length &&!department">
          {{ 'ASSIGN_DEPARTMENT' | translate }}</div>

        <div *ngIf="!department">
          <div class="card sm-12 margin-top-5 btn-main-color" *ngFor="let department of departments"
            (click)="assignDepartmentToConsultant(department)" data-toggle="modal"
            data-target="#addDepartmentToConsultantModal" [title]="'SELECT' | translate">
            <div class="card-header text-row-background-color-white cursor-hand">
              <div class="row">
                <div class="col-7">
                  {{department.id}} - {{department.name}}
                </div>
                <div class="col-3 text-left tex-element-bold">
                </div>

                <div class="col-2 text-right">
                  <div ngbDropdown class="d-inline-block">
                    <i class="fas fa-hand-pointer" aria-hidden="true"></i>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!--  <div *ngIf="department">
          {{ 'ASSIGN_DEPARTMENT' | translate }}
          <div class="card sm-12 margin-top-5 btn-main-color">
            <div class="card-header text-row-background-color-white">
              <div class="row">
                <div class="col-7">
                  {{department.id}} - {{department.name}}
                </div>
                <div class="col-3 text-left tex-element-bold">
                </div>

                <div class="col-2 text-right">
                  <div ngbDropdown class="d-inline-block">
                    <i class="fas fa-hand-pointer cursor-hand" aria-hidden="true"
                      data-toggle="modal" data-target="#addUnitToConsultantModal"
                      (click)="assignUnitToConsultant(department)"
                      [title]="'SELECT' | translate"></i>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div> -->

        <!--      <div class="alert alert-warning margin-top-5" role="alert"
          *ngIf="!_databaseResourcesService.loading && hospital && department && (!subdepartments || !subdepartments.length)">
          {{ 'NO_SUBDEPARTMENTS' | translate }}
        </div>

        <div *ngIf="subdepartments && subdepartments.length">
          {{ 'ASSIGN_SUBDEPARTMENT' | translate }}</div>

        <div class="card sm-12 margin-top-5 btn-main-color"
          *ngFor="let subdepartment of subdepartments">
          <div class="card-header text-row-background-color-white">
            <div class="row">
              <div class="col-7">
                {{subdepartment.id}} - {{subdepartment.name}}
              </div>
              <div class="col-3 text-left tex-element-bold">
              </div>
              <div class="col-2 text-right">
                <div ngbDropdown class="d-inline-block">
                  <i class="fas fa-hand-pointer cursor-hand" aria-hidden="true" data-toggle="modal"
                    data-target="#addUnitToConsultantModal"
                    (click)="assignUnitToConsultant(subdepartment)"
                    [title]="'SELECT' | translate"></i>
                </div>
              </div>
            </div>
          </div>
        </div> -->
      </div>
    </div>
  </div>
</div>


<!-- Add Subepartment to Consultat Modal -->
<div class="modal fade" data-backdrop="static" data-keyboard="false" data-backdrop="static"
  data-keyboard="false" id="addSubdepartmentToConsultantModal" tabindex="-1" role="dialog"
  aria-labelledby="consultantModal" aria-hidden="true">
  <div class="modal-dialog  modal-xl" role="document">
    <div class="modal-content">
      <div class="modal-header btn-main-color">
        <div>{{ 'ADD_SUBDEPARTMENT_TO_CONSULTANT_CONSULTANT_PROFILE' | translate}}</div>
        <h5 class="modal-title" id="departmentconsultantModal"></h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>

      <div class="modal-body">

        <div class="form-row">

          <div class="form-group col-md-12">
            <label>{{ 'CHOOSE_DEPARTMENT' | translate}}</label>
            <div class="input-group mb-3">
              <select name="department" class="form-control" [(ngModel)]=department
                (ngModelChange)="getSubdepartments($event)">
                <option disabled hidden [value]="selectUndefinedOptionValue"></option>
                <option *ngFor="let department of departments" [ngValue]="department">
                  {{ department.name }}
                </option>
              </select>
              <div class="input-group-append">
                <button class="btn btn-outline-secondary" (click)="department = null"
                  [disabled]="!hospital">
                  <i class="fas fa-trash-alt icon-trash"></i>
                </button>
              </div>
            </div>
          </div>
        </div>
        <div class="alert alert-warning alert-dismissible fade show" role="alert"
          *ngIf="_resourceService.alert">
          {{ _resourceService.alert | translate }}
          <button type="button" class="close" data-dismiss="alert" aria-label="Close"
            (click)="_resourceService.alert = null">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>

        <loading-component *ngIf="_databaseResourcesService.loading"></loading-component>


        <div class="alert alert-warning margin-top-5" role="alert"
          *ngIf="!_databaseResourcesService.loading && hospital && department && (!subdepartments || !subdepartments.length)">
          {{ 'NO_SUBDEPARTMENTS' | translate }}
        </div>

        <div class="alert alert-warning margin-top-5" role="alert"
          *ngIf="subdepartments && areAllChoosed(subdepartments, consultant.subdepartments)">
          {{ 'NO_MORE_SUBDEPARTMENTS_TO_ADD' | translate }}
        </div>


        <div
          *ngIf="subdepartments && subdepartments.length && !areAllChoosed(subdepartments, consultant.subdepartments)">
          {{ 'ASSIGN_SUBDEPARTMENT' | translate }}</div>

        <div *ngFor="let subdepartment of subdepartments">


          <div class="card sm-12 margin-top-5 btn-main-color"
            *ngIf="!areInArray(subdepartment, consultant.subdepartments)">
            <div class="card-header text-row-background-color-white">
              <div class="row">
                <div class="col-7">
                  {{subdepartment.id}} - {{subdepartment.name}}
                </div>
                <div class="col-3 text-left tex-element-bold">
                </div>
                <div class="col-2 text-right">
                  <div ngbDropdown class="d-inline-block">
                    <i class="fas fa-hand-pointer cursor-hand" aria-hidden="true"
                      data-toggle="modal" data-target="#addSubdepartmentToConsultantModal"
                      (click)="assignSubdepartmentToConsultant(subdepartment)"
                      [title]="'SELECT' | translate"></i>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>














<!-- Add Unit to Consultat Modal -->
<div class="modal fade" data-backdrop="static" data-keyboard="false" data-backdrop="static"
  data-keyboard="false" id="addUnitToConsultantModal" tabindex="-1" role="dialog"
  aria-labelledby="consultantModal" aria-hidden="true">
  <div class="modal-dialog  modal-xl" role="document">
    <div class="modal-content">
      <div class="modal-header btn-main-color">
        <div>{{ 'ADD_UNIT_TO_CONSULTANT' | translate}}</div>
        <h5 class="modal-title" id="consultantModal"></h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>

      <div class="modal-body">

        <div class="alert alert-warning alert-dismissible fade show" role="alert"
          *ngIf="_resourceService.alert">
          {{ _resourceService.alert | translate }}
          <button type="button" class="close" data-dismiss="alert" aria-label="Close"
            (click)="_resourceService.alert = null">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>

        <div class="form-row">

          <div class="form-group col-md-12">
            <label>{{ 'CHOOSE_HOSPITAL' | translate}}</label>
            <div class="input-group mb-3">
              <select name="hospital" class="form-control" [(ngModel)]=hospital
                (ngModelChange)="getDepartments($event)">
                <option disabled hidden [value]="selectUndefinedOptionValue"></option>
                <option *ngFor="let hospital of _databaseResourcesService.allHospitals"
                  [ngValue]="hospital">
                  {{ hospital.name }}
                </option>
              </select>
              <div class="input-group-append">
                <button class="btn btn-outline-secondary"
                  (click)="hospital = null; departments = null" [disabled]="!hospital">
                  <i class="fas fa-trash-alt icon-trash"></i>
                </button>
              </div>
            </div>
          </div>
        </div>

        <div class="form-row">

          <div class="form-group col-md-12">
            <label>{{ 'CHOOSE_DEPARTMENT' | translate}}</label>
            <div class="input-group mb-3">
              <select name="department" class="form-control" [(ngModel)]=department
                (ngModelChange)="getSubdepartments($event)"
                [disabled]="!hospital || (departments && !departments.length)">
                <option *ngFor="let department of departments" [ngValue]="department">
                  {{ department.name }}
                </option>
              </select>
              <div class="input-group-append">
                <button class="btn btn-outline-secondary"
                  (click)="department = null; subdepartments = null" [disabled]="!department">
                  <i class="fas fa-trash-alt icon-trash"></i>
                </button>
              </div>
            </div>
          </div>
        </div>

        <loading-component *ngIf="_databaseResourcesService.loading"></loading-component>


        <div class="alert alert-warning margin-top-5" role="alert"
          *ngIf="!_databaseResourcesService.loading && hospital && departments && !departments.length">
          {{ 'HOSPITAL_WITHOUT_DEPARTMENTS' | translate }}
        </div>

        <div *ngIf="departments && departments.length &&!department">
          {{ 'ASSIGN_DEPARTMENT_OR_SELECT_TO_ASSIGN' | translate }}</div>

        <div *ngIf="!department">
          <div class="card sm-12 margin-top-5 btn-main-color" *ngFor="let department of departments"
            (click)="assignDepartmentToConsultant(department)">
            <div class="card-header text-row-background-color-white cursor-hand">
              <div class="row">
                <div class="col-7">
                  {{department.id}} - {{department.name}}
                </div>
                <div class="col-3 text-left tex-element-bold">
                </div>

                <div class="col-2 text-right">
                  <div ngbDropdown class="d-inline-block">
                    <i class="fas fa-hand-pointer" aria-hidden="true" data-toggle="modal"
                      data-target="#addUnitToConsultantModal" [title]="'SELECT' | translate"></i>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div *ngIf="department">
          {{ 'ASSIGN_DEPARTMENT' | translate }}
          <div class="card sm-12 margin-top-5 btn-main-color">
            <div class="card-header text-row-background-color-white">
              <div class="row">
                <div class="col-7">
                  {{department.id}} - {{department.name}}
                </div>
                <div class="col-3 text-left tex-element-bold">
                </div>

                <div class="col-2 text-right">
                  <div ngbDropdown class="d-inline-block">
                    <i class="fas fa-hand-pointer cursor-hand" aria-hidden="true"
                      data-toggle="modal" data-target="#addUnitToConsultantModal"
                      (click)="assignDepartmentToConsultant(department)"
                      [title]="'SELECT' | translate"></i>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="alert alert-warning margin-top-5" role="alert"
          *ngIf="!_databaseResourcesService.loading && hospital && department && (!subdepartments || !subdepartments.length)">
          {{ 'NO_SUBDEPARTMENTS' | translate }}
        </div>

        <div *ngIf="subdepartments && subdepartments.length">
          {{ 'ASSIGN_SUBDEPARTMENT' | translate }}</div>

        <div class="card sm-12 margin-top-5 btn-main-color"
          *ngFor="let subdepartment of subdepartments">
          <div class="card-header text-row-background-color-white">
            <div class="row">
              <div class="col-7">
                {{subdepartment.id}} - {{subdepartment.name}}
              </div>
              <div class="col-3 text-left tex-element-bold">
              </div>

              <div class="col-2 text-right">
                <div ngbDropdown class="d-inline-block">
                  <i class="fas fa-hand-pointer cursor-hand" aria-hidden="true" data-toggle="modal"
                    data-target="#addUnitToConsultantModal"
                    (click)="assignUnitToConsultant(subdepartment)"
                    [title]="'SELECT' | translate"></i>
                </div>
              </div>
            </div>
          </div>
        </div>



      </div>
    </div>
  </div>
</div>





<!-- Add Payor to Consultat Modal -->
<div class="modal fade" data-backdrop="static" data-keyboard="false" data-backdrop="static"
  data-keyboard="false" id="addPayorToConsultantModal" tabindex="-1" role="dialog"
  aria-labelledby="payorConsultantModal" aria-hidden="true">
  <div class="modal-dialog  modal-xl" role="document">
    <div class="modal-content">
      <div class="modal-header btn-main-color">
        <div>{{ 'ADD_PAYOR_TO_CONSULTANT' | translate}}</div>
        <h5 class="modal-title" id="payorConsultantModal"></h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>

      <div class="modal-body">

        <div class="alert alert-warning alert-dismissible fade show" role="alert"
          *ngIf="_resourceService.alert">
          {{ _resourceService.alert | translate }}
          <button type="button" class="close" data-dismiss="alert" aria-label="Close"
            (click)="_resourceService.alert = null">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>

        <div class="alert alert-warning margin-top-5" role="alert"
          *ngIf="!_databaseResourcesService.payors?.length">
          {{ 'PLEASE_CREATE_PAYORS' | translate }}
        </div>

        <div
          *ngIf="consultant.payors && _databaseResourcesService.payors.length == consultant.payors.length">
          <div class="alert alert-warning alert-dismissible fade show" role="alert">
            {{ 'NO_MORE_PAYORS_TO_ADD' | translate }}
          </div>
        </div>

        <div class="input-group mb-3"
          *ngIf="_databaseResourcesService.payors?.length != consultant.payors?.length">
          <div class="input-group-prepend">
            <span class="input-group-text background-main-color"><i
                class="fas fa-filter"></i></span>
          </div>
          <input type="text" class="form-control" placeholder="{{ 'FILTER_PAYORS' | translate }}"
            [(ngModel)]="searchpayor">
        </div>

        <div
          *ngIf="consultant.payors && _databaseResourcesService.payors.length != consultant.payors.length">
          <div *ngFor="let payor of _databaseResourcesService.payors | searchfilter :searchpayor">
            <div class="card sm-12 margin-top-5 btn-main-color"
              *ngIf="!areInArray(payor, consultant.payors)"
              (click)="assignPayorToConsultant(payor); searchpayor = ''" data-toggle="modal"
              data-target="#addPayorToConsultantModal" [title]="'SELECT' | translate">
              <div class="card-header text-row-background-color-white cursor-hand">
                <div class="row">
                  <div class="col-7">
                    {{payor.id}} - {{payor.name}}
                  </div>
                  <div class="col-3 text-left tex-element-bold">
                  </div>

                  <div class="col-2 text-right">
                    <div ngbDropdown class="d-inline-block">
                      <i class="fas fa-hand-pointer" aria-hidden="true"></i>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>


<!-- Add Assistant to Consultat Modal -->
<div class="modal fade" data-backdrop="static" data-keyboard="false" data-backdrop="static"
  data-keyboard="false" id="addAssistantToConsultantModal" tabindex="-1" role="dialog"
  aria-labelledby="assistantConsultantModal" aria-hidden="true">
  <div class="modal-dialog  modal-xl" role="document">
    <div class="modal-content">
      <div class="modal-header btn-main-color">
        <div>{{ 'ADD_ASSISTANT_TO_CONSULTANT' | translate}}</div>
        <h5 class="modal-title" id="assistantConsultantModal"></h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>

      <div class="modal-body">

        <div class="alert alert-warning alert-dismissible fade show" role="alert"
          *ngIf="_resourceService.alert">
          {{ _resourceService.alert | translate }}
          <button type="button" class="close" data-dismiss="alert" aria-label="Close"
            (click)="_resourceService.alert = null">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="alert alert-warning margin-top-5" role="alert"
          *ngIf="!_databaseResourcesService.assistants?.length">
          {{ 'NO_ASSISTANTS' | translate }}
        </div>

        <div
          *ngIf="consultant.assistants && _databaseResourcesService.assistants?.length == consultant.assistants?.length">
          <div class="alert alert-warning alert-dismissible fade show" role="alert">
            {{ 'NO_MORE_ASSISTANTS_TO_ADD' | translate }}
          </div>
        </div>

        <div class="input-group mb-3"
          *ngIf="_databaseResourcesService.assistants?.length != consultant.assistants?.length">
          <div class="input-group-prepend">
            <span class="input-group-text background-main-color"><i
                class="fas fa-filter"></i></span>
          </div>
          <input type="text" class="form-control"
            placeholder="{{ 'FILTER_ASSISTANTS' | translate }}" [(ngModel)]="searchassistant">
        </div>


        <div
          *ngIf="consultant.assistants && _databaseResourcesService.assistants?.length != consultant.assistants?.length">
          <div
            *ngFor="let assistant of _databaseResourcesService.assistants | searchfilter :searchassistant">
            <div class="card sm-12 margin-top-5 btn-main-color"
              *ngIf="!areInArrayByMail(assistant, consultant.assistants)"
              (click)="assignAssistantToConsultant(assistant); searchassistant = ''"
              data-toggle="modal" data-target="#addAssistantToConsultantModal"
              [title]="'SELECT' | translate">
              <div class="card-header text-row-background-color-white cursor-hand">
                <div class="row">
                  <div class="col-7">
                    {{assistant.email}} - {{assistant.name}} {{assistant.lastname}}
                  </div>
                  <div class="col-3 text-left tex-element-bold">
                  </div>

                  <div class="col-2 text-right">
                    <div ngbDropdown class="d-inline-block">
                      <i class="fas fa-hand-pointer" aria-hidden="true"></i>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>